import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

export const fetchAdGroupCopyHistory = createAxiosThunk(
  'bulk/fetchAdGroupCopyHistory',
  (noArgs, { getState }) => {
    const { page, size } = getState().bulk.adGroupCopy
    return api.bulk.getAdGroupCopyHistory(page, size)
  }
)
export const retryAdGroupCopy = createAxiosThunk(
  'bulk/retryAdGroupCopy',
  adGroupId => api.bulk.putAdGroupCopyRetry(adGroupId)
)

const initialState = {
  isLoading: false,
  content: [],
  page: 0,
  size: 20,
  totalElements: 0,
  error: null,
  disabledRetry: false,
}
const adGroupCopyHistorySlice = createSlice({
  name: 'bulk/adGroupCopy',
  initialState,

  reducers: {
    setPage: (state, { payload: page }) => {
      state.page = page
    },
    setSize: (state, { payload: size }) => {
      state.size = size
    },
    reset: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchAdGroupCopyHistory.pending, state => {
      state.isLoading = true
      state.error = null
    })

    builder.addCase(fetchAdGroupCopyHistory.rejected, (state, { payload }) => {
      state.isLoading = false
      state.content = []
      state.totalElements = 0
      state.error = payload
    })

    builder.addCase(fetchAdGroupCopyHistory.fulfilled, (state, { payload }) => {
      state.isLoading = false
      state.content = payload.histories
      state.totalElements = payload.totalElements
    })

    builder.addCase(retryAdGroupCopy.pending, state => {
      state.disabledRetry = true
    })

    builder.addCase(retryAdGroupCopy.rejected, state => {
      state.disabledRetry = false
    })

    builder.addCase(retryAdGroupCopy.fulfilled, state => {
      state.disabledRetry = false
    })
  },
})
const { actions, reducer } = adGroupCopyHistorySlice
export const { setPage, setSize, reset } = actions
export default reducer
